// Increase the height of featured product in slider on Homepage
window.addEventListener('load', () => {

//   if (window.innerWidth <= 1024) {

//     const checkSlider = setInterval(() => {

//       const items = document.querySelectorAll(
//         '.shop-the-look .flickity-enabled.is-draggable .flickity-viewport ,.product-card__spec'
//       );
//       if (items.length) {
//         items.forEach((el) => {
//           const currentHeight = el.offsetHeight;
//           el.style.height = (currentHeight + 70) + 'px';
//         });
//         clearInterval(checkSlider);
//       }
//     }, 200);
// }
// document.querySelectorAll(".offer-card.is-selected").forEach(function(el) {
//       el.addEventListener("click", function() {
//         var checkbox = this.querySelector(".offer-card__footer input.upsell-check");

//         if (checkbox && checkbox.checked) {
//           checkbox.checked = false;
//         }else{
//             checkbox.checked = true;
//         }
//         return false;
//       });
//     });
// });
// theme.pubsub.subscribe(
//   theme.pubsub.PUB_SUB_EVENTS.variantChange,
//   (event) => {
//     document.querySelectorAll(".offer-card.is-selected").forEach(function(el) {
//       el.addEventListener("click", function() {
//         var checkbox = this.querySelector(".offer-card__footer input.upsell-check");
//           console.log(checkbox);
//         if (checkbox && checkbox.checked) {
//           checkbox.checked = false;
//         }else{
//             checkbox.checked = true;
//         }
//          return false;
//       });
//     });
//   }
// );


function initOfferCardUpsells() {
  document.querySelectorAll(".offer-card").forEach(function(card) {
    card.removeEventListener("click", card.offerCardHandler);

    card.offerCardHandler = function(e) {
      const checkbox = card.querySelector(
        ".offer-card__footer input.upsell-check"
      );

      console.log(checkbox);
      // Remove is-selected class if upsell-check exists
      if (checkbox) {
        card.classList.remove("is-selected");
      }

      if (!card.classList.contains("is-selected")) {
        return;
      }

      if (!checkbox) return;

      checkbox.checked = !checkbox.checked;

      if (checkbox.checked) {
        card.classList.add("upsell-active");
      } else {
        card.classList.remove("upsell-active");
      }
    };

    card.addEventListener("click", card.offerCardHandler);
  });
}





document.addEventListener("DOMContentLoaded", () => {
  initOfferCardUpsells();
});

theme.pubsub.subscribe(
  theme.pubsub.PUB_SUB_EVENTS.variantChange,
  () => {
    initOfferCardUpsells();
  }
);



document.addEventListener('quickview:open', function(evt) {
    console.log("initOfferCardUpsells run",evt.target);
    initOfferCardUpsells();
});


});

document.addEventListener('DOMContentLoaded', () => {

  const offerCards = document.querySelectorAll('.offer-card');

  // Select second offer card
  if (offerCards.length > 1) {

    const secondCard = offerCards[1];

    // trigger radio/select click
    const input = secondCard.querySelector(
      'input[type="radio"], input[type="checkbox"]'
    );

    if (input) {

      input.checked = true;

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );

      input.click();

    }

  }

});

// Mute / Unmute on icon click
document.querySelectorAll('.video-wrapper').forEach(wrapper => {
  const video = wrapper.querySelector('.video_links');
  const soundToggle = wrapper.querySelector('.sound-toggle');

  soundToggle.addEventListener('click', (e) => {
    e.stopPropagation();

    video.muted = !video.muted;

    // Toggle visibility of the two SVG icons
    soundToggle.querySelector('.mute-off').style.display = video.muted ? 'block' : 'none';
    soundToggle.querySelector('.mute-on').style.display = video.muted ? 'none' : 'block';
  });
});
// for Metafield reviews 
document.addEventListener("DOMContentLoaded", () => {
  const reviewCount = document.querySelector(".custom-reviews-jtpl")?.dataset.reviews;
  if (!reviewCount) return;

  const observer = new MutationObserver(() => {
    const count = document.querySelector(".oke-w-reviews-controls .oke-w-reviews-count");
    if (count && count.textContent !== reviewCount) {
      count.textContent = reviewCount;
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // Stop after 5 seconds
  setTimeout(() => observer.disconnect(), 5000);

  
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewTrigger = document.querySelector(".custom-reviews-jtpl");

  if (!reviewTrigger) return;

  reviewTrigger.addEventListener("click", function (e) {
    e.preventDefault();

    const reviewsSection = document.querySelector(".oke-w-reviewsTab");

    if (reviewsSection) {
      reviewsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});


// Product recommendations - AJAX add to cart
document.addEventListener('submit', async function (event) {
  const form = event.target;

  // Only recommendation product forms
  if (
    !form.matches(
      'product-recommendations form[action="/cart/add"], product-recommendations form[action$="/cart/add"]'
    )
  ) {
    return;
  }

  // Prevent the theme's product-form from adding the product again
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const button = form.querySelector('button[type="submit"]');

  if (button) {
    button.disabled = true;
    button.classList.add('loading');
  }

  try {
    // Get variant ID
    const variantId = form.querySelector('input[name="id"]')?.value;

    if (!variantId) {
      throw new Error('Variant ID not found');
    }

  
    // Add exactly ONE product
    const addResponse = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      }
    );

    const addData = await addResponse.json();

    if (!addResponse.ok) {
      throw new Error(
        addData.description || 'Unable to add product to cart'
      );
    }

    // Get the updated cart through AJAX
    const cartResponse = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      }
    );

    if (!cartResponse.ok) {
      throw new Error('Unable to get updated cart');
    }

    const cart = await cartResponse.json();

    // console.log('Updated cart item count:', cart.item_count);


    const sectionId =
      form.querySelector('input[name="section-id"]')?.value;

    // Refresh cart drawer through AJAX
    if (sectionId) {
      const sectionResponse = await fetch(
        `${window.Shopify.routes.root}?sections=${encodeURIComponent(sectionId)}`,
        {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          cache: 'no-store'
        }
      );

      if (sectionResponse.ok) {
        const sections = await sectionResponse.json();
        const html = sections[sectionId];

        if (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const currentDrawer =
            document.querySelector(`#MiniCart-${sectionId}`) ||
            document.querySelector('cart-drawer') ||
            document.querySelector('#CartDrawer');

          const updatedDrawer =
            doc.querySelector(`#MiniCart-${sectionId}`) ||
            doc.querySelector('cart-drawer') ||
            document.querySelector('#CartDrawer');

          if (currentDrawer && updatedDrawer) {
            // Replace drawer content with fresh Shopify HTML
            currentDrawer.innerHTML = updatedDrawer.innerHTML;

            // Keep drawer attributes
            Array.from(updatedDrawer.attributes).forEach(attribute => {
              if (attribute.name !== 'id') {
                currentDrawer.setAttribute(
                  attribute.name,
                  attribute.value
                );
              }
            });
          }
        }
      }
    }

    // UPDATE <cart-count>
    document.querySelectorAll('cart-count').forEach((element) => {
      element.textContent = cart.item_count;
      element.setAttribute(
        'aria-label',
        `${cart.item_count} items`
      );
    });

    // Also update common cart count selectors in case the theme has another cart counter
    document.querySelectorAll(
      '[data-cart-count], [data-cart-item-count], .cart-count-bubble'
    ).forEach((element) => {
      element.textContent = cart.item_count;

      if (cart.item_count > 0) {
        element.removeAttribute('hidden');
      } else {
        element.setAttribute('hidden', '');
      }
    });

    // Dispatch cart updated event
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: cart,
          item: addData
        }
      })
    );

    // Open cart drawer 
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="CartDrawer"]');

    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.removeAttribute('hidden');
        drawer.classList.add('is-open', 'active');
      }
    }

  } catch (error) {
    console.error(
      'Recommendation add-to-cart error:',
      error
    );
  } finally {
    if (button) {
      button.disabled = false;
      button.classList.remove('loading');
    }
  }
}, true);